import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import { DataAccessUtils } from '@assets/model/DataAccessUtils';
import { useStoreUI } from './Store';

export interface ChatMessageData {
    isMe: boolean;
    message: string;
    date: Date;
    response?: string;
    processed: boolean;
    id?: string;
    raw?: any;
}

export class RagAPI {
    private static accessTokenAPI: string = null; //This can be static
    private query: DataAccessUtils = null;

    constructor(public reportId: string) {}

    async init(query: DataAccessUtils) {
        this.query = query;
    }

    async sendMessage(question: string) {
        const query = this.query;
        const storeUI = useStoreUI();
        const fb = getFirebase();

        storeUI.chatWaitingForResponse = true;

        try {
            fb.chatbot_add_message(this.reportId, question, true);

            storeUI.chatWaitingForResponse = false;
        } catch (e) {
            storeUI.chatWaitingForResponse = false;
        }
    }
}
